import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import store from "./redux/store";
import { Theme } from "./features/theme/Theme";
import swDev from "./swDev";
import * as serviceWorker from "./serviceWorker";
import "typeface-poppins";

ReactDOM.render(
  <Provider store={store}>
    <Router>
      <Theme>
        <App />
      </Theme>
    </Router>
  </Provider>,
  document.getElementById("root")
);

serviceWorker.unregister(); //inform the web team before changing this to register
swDev();

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((registration) => {
        console.log("SW registered: ", registration);
      })
      .catch((registrationError) => {
        console.log("SW registration failed: ", registrationError);
      });
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
